module.exports = __webpack_public_path__ + "img/join-us.55c4bb6a.jpg";